import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const HideContainer_Hide_1 = styled.div`
  display: block;

  &:where([data-hide-xs]) {
    display: none;
  }

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    display: block;
    &:where([data-hide-sm]) {
      display: none;
    }
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: block;
    &:where([data-hide-md]) {
      display: none;
    }
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: block;
    &:where([data-hide-lg]) {
      display: none;
    }
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    display: block;
    &:where([data-hide-xl]) {
      display: none;
    }
  }
`;
